export default "__VITE_ASSET__B9aPMP4q__"